import {
  Article,
  ArticleAction,
  ArticleImage,
  ArticleList,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { Button } from "@babackapp/customer-ui/components/button";
import { usePublicOrder } from "@babackapp/return-widget-components/queries/use-public-order";
import { getOrderCurrency } from "@babackapp/return-widget-components/lib/financials.lib";
import { formatPrice } from "@babackapp/return-widget-components/utils/format-price";
import { parseLineItemPriceInCents } from "@babackapp/return-widget-components/utils/get-line-item-price";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useLineItemLayout } from "../../hooks/use-line-item-layout";
import { useWidgetParams } from "../../hooks/use-widget-params";
import { formatVariantOptions } from "../../utils/format-variant-options";

export function LineItemBar() {
  const {
    lineItem,
    quantity,
    setQuantity,
    returnableQty,
    removeItem,
    lineItemId,
  } = useLineItemLayout();
  const { orderId } = useWidgetParams();
  const { data: order } = usePublicOrder(orderId);
  const currency = getOrderCurrency(order);

  if (!lineItem) return null;

  const options = formatVariantOptions(lineItem);
  const priceCents = parseLineItemPriceInCents(lineItem.price);
  const price = priceCents != null ? formatPrice(priceCents, currency) : null;
  const subtitle = [options, price].filter(Boolean).join(" • ") || null;

  return (
    <ArticleList
      className="absolute bottom-4 left-4 w-auto right-4 z-10 drop-shadow-md overflow-hidden bg-background"
      variants={{}}
      initial={{ y: 100 }}
      animate={{ y: 0, transition: { type: "spring" } }}
      exit={{ y: 100 }}
    >
      <Article>
        <ArticleImage
          src={lineItem.image ?? undefined}
          layoutId={`img-${lineItemId}`}
        />
        <ArticleTitle>{lineItem.title}</ArticleTitle>
        {subtitle && <ArticleSubtitle>{subtitle}</ArticleSubtitle>}
        <ArticleAction autoHide={false}>
          {returnableQty > 1 ? (
            <div className="flex items-center gap-1 border rounded-lg h-8 px-1 text-xs font-mono font-medium tabular-nums">
              <button
                type="button"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                className="px-1 text-muted-foreground hover:text-foreground cursor-pointer"
              >
                <Minus className="size-3" />
              </button>
              <span className="min-w-4 text-center">{quantity}</span>
              <button
                type="button"
                onClick={() =>
                  setQuantity(Math.min(returnableQty, quantity + 1))
                }
                className="px-1 text-muted-foreground hover:text-foreground cursor-pointer"
              >
                <Plus className="size-3" />
              </button>
            </div>
          ) : (
            <span className="text-xs font-mono font-medium tabular-nums text-muted-foreground">
              ×1
            </span>
          )}
          <Button
            size="icon"
            variant="outline"
            type="button"
            onClick={removeItem}
          >
            <Trash2 />
          </Button>
        </ArticleAction>
      </Article>
    </ArticleList>
  );
}
